var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-modal',{ref:"modal",attrs:{"modal-id":_vm.modalId,"title":_vm.s__('UserMapping|Keep all as placeholders?'),"action-primary":_vm.$options.primaryAction,"action-cancel":_vm.$options.cancelAction},on:{"primary":_vm.keepAllAsPlaceholder}},[_vm._v("\n  "+_vm._s(_vm.s__(
      'UserMapping|If you keep all as placeholders, you cannot reassign their contributions to users at a later time. Ensure all required reassignments are completed before you keep all as placeholders.',
    ))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }